import ResourceTyped from 'Resources/ResourceTyped';
import type { FetchedIntegrations, SearchResponse } from 'App/components/hooks/integrations/externalIntegrationTypes';

class ExternalIntegrationResource extends ResourceTyped<string> {
	constructor() {
		super('externalIntegration');
	}

	token(type: 'paragon'): Promise<{ paragonToken: string; upsalesToken: string; projectId: string }> {
		return this._getRequest(`token/${type}`).then(res => res.data);
	}

	getIntegrations(type: 'paragon'): Promise<FetchedIntegrations> {
		return this._getRequest(`integrations/${type}`).then(res => res.data);
	}

	executionSearch(type: 'paragon', options: any): Promise<SearchResponse> {
		return this._postRequest(`executionSearch/${type}`, options).then(res => res.data);
	}
}

const resource = new ExternalIntegrationResource();

export default resource;
